module.exports = __webpack_public_path__ + "static/img/labourservices-3.ac8bb59.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-3.png
// module id = 7yTg
// module chunks = 1